module.exports = __webpack_public_path__ + "static/media/cent_sign.1da99cb4.svg";